import React, { useState } from 'react';
import { withoutNormalizing } from '@udecode/plate';
import { useEditorRef, focusEditor, useEventPlateId } from '@udecode/plate-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import SubmitInputField from 'components/FormFields/SubmitInputField';
import APModal from 'components/Modal/APModal';
import { parseVideoUrl } from 'utils/urls';
import { ToolbarButton } from './ToolbarButton';
import { insertMediaEmbed } from '../../plugins/media/embed/insertMediaEmbed';
import { insertEmptyElementAfter } from '../../utils/insertEmptyElementAfter';

export const MediaEmbedButton = ({ id }) => {
  const editor = useEditorRef(useEventPlateId(id));
  const [showEmbedModal, setShowEmbedModal] = useState(false);
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  const close = () => {
    setShowEmbedModal(false);
    setUrl('');
    setError('');
  };

  const embedMedia = (e) => {
    e.preventDefault();
    e.stopPropagation();
    submit();
  };

  const submit = () => {
    setError('');
    const { url: validatedUrl } = parseVideoUrl(url) || {};
    if (!validatedUrl) {
      setError('Please check your video URL and update as needed to embed your video.');
      return;
    }

    withoutNormalizing(editor, () => {
      insertMediaEmbed(editor, { url });
      insertEmptyElementAfter(editor, { mode: 'highest' });
    });
    setTimeout(() => {
      focusEditor(editor, editor.selection);
    }, 0);
    close();
  };

  return (
    <>
      <ToolbarButton
        name="Embed video"
        className={clsx('button--unstyled')}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowEmbedModal(true);
        }}
        onMouseDown={(e) => e.preventDefault()}
      >
        <FontAwesomeIcon icon={['fab', 'youtube']} />
      </ToolbarButton>
      {showEmbedModal && (
        <APModal
          open
          onClose={close}
          width={620}
          height={300}
          name="embed-video"
          title="Add your video"
          subtitle="To embed a video, enter your URL. We currently support videos hosted on Youtube and Vimeo."
          errorMsg={error}
          actions={(
            <>
              <button
                className="button"
                onClick={embedMedia}
                disabled={!url}
              >
                Save
              </button>
            </>
          )}
        >
          <div className="inputbox_group form-item form-item--text form-group">
            <label
              htmlFor="media-embed-url"
              className="inputbox-label form-item__label"
            >
              URL
            </label>
            <SubmitInputField
              type="text"
              value={url}
              className={clsx('form-control', error !== '' && 'error')}
              onChange={(e) => {
                setUrl(e.target.value);
              }}
              handleSubmit={submit}
            />
          </div>
        </APModal>
      )}
    </>
  );
};
